import { Autocomplete, TextField } from '@mui/material';
import React, { FC } from 'react';
import { MerchantSummaryDto } from '@services';
import styles from './MerchantSelectionComponent.module.scss';
import { useAppSelector } from '../../../../app/hooks';
import { selectAllMerchants } from '../../auth/authSlice';

interface MerchantSelectionComponentProps {
    onChange: (merchant: MerchantSummaryDto | null) => void;
    selectedMerchantId: number;
}

const MerchantSelectionComponent: FC<MerchantSelectionComponentProps> = (props) => {
    const { onChange, selectedMerchantId } = props;
    const merchants = useAppSelector(selectAllMerchants);
    const selectedMerchant = merchants.length > 1 ? merchants.find((m) => m!.id! === selectedMerchantId) : merchants[0];

    return (
        <div className={styles.MerchantSelectionComponent} data-testid="MerchantSelectionComponent">
            <Autocomplete
                value={selectedMerchant ?? null}
                disabled={merchants.length < 2}
                disableClearable={merchants.length < 2}
                getOptionLabel={(o) => o?.name!}
                options={merchants}
                onChange={(e, newValue: MerchantSummaryDto | null | undefined) => onChange(newValue ?? null)}
                renderInput={(params) => (
                    <TextField
                        /* eslint-disable-next-line react/jsx-props-no-spreading */
                        {...params}
                        label="Merchant"
                    />
                )}
            />
        </div>
    );
};
export default MerchantSelectionComponent;
